<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="modal-big">
    <woot-modal-header
      :header-title="$t('CANNED_MGMT.HEADER')"
      :header-content="$t('CANNED_MGMT.TEXT_DESCRIPTION')"
    />
    <div class="row modal-content">
      <canned-responses-picker
        :inbox-id="inboxId"
        :canned-filter="cannedFilters"
        @onSelect="pickCanned"
      />
    </div>
  </woot-modal>
</template>

<script>
import CannedResponsesPicker from './CannedResponsesPicker';

export default {
  components: {
    CannedResponsesPicker,
  },
  props: {
    inboxId: {
      type: Number,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cannedFilters() {
      return {
        marketing: false,
        utility: true,
      };
    },
  },
  methods: {
    pickCanned(canned) {
      const message = {
        message: canned.content,
        cannedParams: {
          name: canned.short_code,
        },
      };
      this.$emit('on-send', message);
      this.onClose();
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.modal-content {
  padding: 2.5rem 3.2rem;
}
</style>
